import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import CategoryPage from './pages/CategoryPage';
import SearchPage from './pages/SearchPage';
import AuthCallback from './pages/AuthCallback';
import AdminDashboard from './pages/admin/AdminDashboard';
import EditorDashboard from './pages/editor/EditorDashboard';
import EditorArticleWriter from './pages/editor/EditorArticleWriter';
import PodcastPage from './pages/PodcastPage';
import PodcastListPage from './pages/PodcastListPage';
import VideosPage from './pages/VideosPage';

function AppRouter() {
  const location = useLocation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  const isAdmin = location.pathname.startsWith('/admin');
  const isEditor = location.pathname.startsWith('/editor');
  const showLayout = !isAdmin && !isEditor;

  return (
    <div className="min-h-screen flex flex-col bg-[#f8f8f8]">
      {showLayout && <Navbar />}
      {(isAdmin || isEditor) && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/article/:id" element={<ArticlePage />} />
          <Route path="/category/:id" element={<CategoryPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/podcasts" element={<PodcastListPage />} />
          <Route path="/podcast/:id" element={<PodcastPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/editor" element={<EditorDashboard />} />
          <Route path="/editor/write" element={<EditorArticleWriter />} />
        </Routes>
      </main>
      {showLayout && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
